module.exports = __webpack_public_path__ + "static/media/bg2.e0954577.jpg";